import styled from 'styled-components'

export const DeacriptionDiv = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
`;

export const ContainerDivSku = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-bottom: solid 1px white;
`

export const Sku = styled.p`
  color: #FFF;
  font-size: 14px;
  text-align: right;
  margin: 0;
`

